export const fetchPipelineHooksAction = 'fetchPipelineHooksAction';
